<template>
    <div class="LibraryULComponent">
        <b-container v-if="!exists">
            <br>
            <p>{{ lang.infotext_1 }}</p>
        </b-container>

        <b-container v-if="exists" v-show="!isDeriving">
            <span v-if="!itemAvailable">
                <br>
                <p v-show="source == 'symbol'">{{ lang.infotext_2 }}</p>
                <p v-show="source == 'hdl symbol'">{{ lang.infotext_3 }}</p>
                <p v-show="source == 'footprint'">{{ lang.infotext_4 }}</p>
            </span>
            <span v-if="itemAvailable">
                <b-row>
                    <b-col cols="2">
                    </b-col>
                    <b-col cols="4">
                        <p class="name">{{ lang.infotext_5 }}: {{svgName}}</p>
                    </b-col>
                    <b-col cols="4">
                        <!-- {{svgNameDetails}} -->
                    </b-col>
                    <b-col cols="2">
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="2">
                        <p>{{ lang.infotext_6 }}:</p>
                        <img class="ul-logo" src="/static/ul-logo.svg">
                    </b-col>
                    <b-col cols="4">




                        <div id="place_svg" class="svg-img"></div>
                        <p>{{ lang.infotext_7 }}: {{svgType}}</p>
                    </b-col>
                    <b-col cols="4">


                        <!-- <p>Name: {{svgNameDetails}}</p> -->

                        <div v-show="source=='footprint'" id="place_svg_details" class="svg-img"></div>
                        <p v-show="source=='footprint'">{{ lang.infotext_8 }}: {{svgTypeDetails}}</p>
                    </b-col>
                    <b-col cols="2">
                        <b-button @click="deriveLibrary" :disabled="formatSelected == null" size="sm"  :variant="variant">{{ lang.button_DeriveULLIbrary }}</b-button>

                    </b-col>


                </b-row>
                <b-row>
                    <b-col cols="2">
                    </b-col>
                    <b-col cols="8">
                        <br>
                        <b-form-group id="input-group-Formats" :label="lang.infotext_10 + ':'" label-for="input-2">
                            <b-form-select v-model="formatSelected" :options="formatOptions" size="sm" class="mt-3">
                            </b-form-select>
                        </b-form-group>



                    </b-col>
                    <b-col cols="2">
                    </b-col>
                </b-row>
            </span>
        </b-container>
        <b-container v-if="isDeriving">
            <b-row>
                <b-col cols="2">
                    <br>
                    <b-button @click="back" size="sm" :variant="variant">{{ lang.button_Back }}</b-button>
                </b-col>
                <b-col cols="8">
                    <br>
                    <p class="name">{{ lang.infotext_9 }}: {{svgName}}</p>
                    <CategoryULComponent :lang="lang.CategoryUL" :source="source"></CategoryULComponent>
                    
                    <NewLibraryFormULComponent :lang="lang.DeriveULLibraryForm" :source="source"
                        :libraryNumber="svgName">
                    </NewLibraryFormULComponent>
                    
                </b-col>
                <b-col cols="2">
                    <br>
                    <b-button @click="createNew" :disabled="disabledState" size="sm" :variant="variant" class="button-create"><b-spinner v-show="isCreating" small></b-spinner> {{ lang.button_CreateNew }}</b-button>
                </b-col>
            </b-row>




        </b-container>




    </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import NewLibraryFormULComponent from '@/components/shared/NewLibraryFormULComponent'
import CategoryULComponent from '@/components/shared/CategoryULComponent'

import PartPropertiesType from '@/constants/PartPropertiesType'

export default {
    name: 'LibraryULComponent',
    props:{
        lang: Object,
        item: Object,
        source: String
    },
    components: {
        NewLibraryFormULComponent,
        CategoryULComponent

    },
    data () {
        return {
            formats: [],
            options: {},
            partDetails: {},
            isDeriving: false,
            formatSelected: null,
            formatOptions: [
                {value: null, text: this.lang.dropdown_FirstValue }
            ],
            disabledState: true,
            isCreating: false
        }
    },
    computed: {
        exists() {
            return this.item.exists;
        },
        itemAvailable() {
            if (this.source == PartPropertiesType.SYMBOL) {
                return this.item.part_data.symbol_available;
            }
            if (this.source == PartPropertiesType.HDLSYMBOL) {
                return this.item.part_data.symbol_available;
            }
            if (this.source == PartPropertiesType.FOOTPRINT) {
                return this.item.part_data.footprint_available;
            }
            return false;
        },
        svg() {
            if (this.partDetails.preview_data == undefined) {
                return
            }
            if (this.source == PartPropertiesType.FOOTPRINT) {
                return this.partDetails.preview_data.footprint_previews[0].data
            }
            if (this.source == PartPropertiesType.SYMBOL) {
                return this.partDetails.preview_data.symbol_previews[0].data
            }
            if (this.source == "hdl symbol") {
                return this.partDetails.preview_data.symbol_previews[0].data
            }
     
        },
        svgType() {
            if (this.partDetails.preview_data == undefined) {
                return
            }
            if (this.source == PartPropertiesType.FOOTPRINT) {
                return this.partDetails.preview_data.footprint_previews[0].type
            }
            if (this.source == PartPropertiesType.SYMBOL) {
                return this.partDetails.preview_data.symbol_previews[0].type
            }
            if (this.source == PartPropertiesType.HDLSYMBOL) {
                return this.partDetails.preview_data.symbol_previews[0].type
            }
            
        },
        svgName() {
            if (this.partDetails.preview_data == undefined) {
                return
            }
            if (this.source == PartPropertiesType.FOOTPRINT) {
                return this.partDetails.preview_data.footprint_previews[0].name
            }
            if (this.source == PartPropertiesType.SYMBOL) {
                return this.partDetails.preview_data.symbol_previews[0].name
            }
            if (this.source == PartPropertiesType.HDLSYMBOL) {
                return this.partDetails.preview_data.symbol_previews[0].name
            }
            
        },
        svgDetails() {
            if (this.partDetails.preview_data == undefined) {
                return
            }
            if (this.source == PartPropertiesType.FOOTPRINT) {
                return this.partDetails.preview_data.footprint_previews[1].data
            }
            // if (this.source == "symbol") {
            //     if (this.partDetails.preview_data.symbol_previews.length > 0) {
            //         return this.partDetails.preview_data.symbol_previews[1].data
            //     }
            // }
            return ""
        },
        svgTypeDetails() {
            if (this.partDetails.preview_data == undefined) {
                return
            }
            if (this.source == PartPropertiesType.FOOTPRINT) {
                return this.partDetails.preview_data.footprint_previews[1].type
            }
            // if (this.source == "symbol") {
            //     if (this.partDetails.preview_data.symbol_previews.length > 0) {
            //         return this.partDetails.preview_data.symbol_previews[1].type
            //     }
            // }
            return ""
        },
        svgNameDetails() {
            if (this.partDetails.preview_data == undefined) {
                return
            }
            if (this.source == PartPropertiesType.FOOTPRINT) {
                return this.partDetails.preview_data.footprint_previews[1].name
            }
            // if (this.source == "symbol") {
            //     if (this.partDetails.preview_data.symbol_previews.length > 0) {
            //         return this.partDetails.preview_data.symbol_previews[1].name
            //     }
                
            // }
            return ""
        },
        libraryName() {

            let libName = "";
            for (let i = 0, lei = this.$store.getters.propertyToSavingUL.length; i < lei; i++){

                if (this.$store.getters.propertyToSavingUL[i].type == "library number") {
                    libName = this.$store.getters.propertyToSavingUL[i].value;
                    break;
                }
            }

            return libName;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
    },
    created () {
        
        if (this.item.exists == true) {
            this.getDetails();
        }
        
        

    },
    watch: {
        svg: function (newVal, oldVal) {
            

        },
        item: function (newVal, oldval) {
            
            if (this.item.exists == true) {
                this.getDetails();
            } else {
                
            }
        }
    },
    updated() {
        
    },
    mounted: function () {
        
    },
    methods: {
        setDisabledState(value) {
            
            this.disabledState = value;
        },
        getDetails() {

            let vue = this;
            const obj = {
                uid: this.item.part_data.uid
            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + '_getDetails', obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {

                        if (result.data != null) {
                            vue.partDetails = result.data;

                            vue.loadSVG();
                        } else {

                        }

                    }
                })
            this.$store.dispatch(this.$store.getters.sectionPrefix + '_getFormats', obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {

                        if (result.data != null) {
                            vue.formats = result.data;

                            for (let i = 0, lei = result.data.length; i < lei; i++){

                                let obj = {
                                    value: result.data[i].id,
                                    text: result.data[i].group_name + " - " + result.data[i].name
                                }
                                this.formatOptions.push(obj);

                            }
                        } else {

                        }

                    }
                })
            this.$store.dispatch(this.$store.getters.sectionPrefix + '_getOptions')
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {

                        if (result.data != null) {
                            vue.options = result.data;
                        } else {

                        }

                    }
                })

        },
        loadSVG() {
            
            let place = document.getElementById("place_svg")
            
            if (place == null) {
                return
            }
            place.innerHTML = this.svg;

            let placeDetails = document.getElementById("place_svg_details")
            
            if (placeDetails == null) {
                return
            }
            placeDetails.innerHTML = this.svgDetails;
        },
        deriveLibrary() {

            
            this.isDeriving = true;

        },
        back() {

            
            this.isDeriving = false;

        },
        createNew() {
            
            let vue = this;

            this.isCreating = true;

            const objModal = {
                ok: true,
                cancel: true
            }

            vue.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)
            
            

            let obj = {
                categoryId: this.$store.getters.libraryULObject.categoryId,
                values: this.$store.getters.propertyToSavingUL,
                distributorPartId: ""
            }


            this.$store.dispatch("lm_createNewLibrary", obj)
                .then(function (result) {

                    console.log(result)

                    if (result.status == "OK") {

                        if (result.data != null) {

                            const goalObj = result.data;

                            let revisionId = result.data.revisionId;

                            vue.saving = true;

                            let obj = {
                                text: "The new library has been saved.",
                                time: 10,
                                type: "success"
                            }
                            vue.$store.dispatch("displayFooterAlert", obj);

                            const modalAlert = {
                                text: "The new library has been saved.",
                                time: 10,
                                type: "success"
                            }
                            vue.$store.commit("SETMODALALERT", modalAlert);


                            let objAppend = {
                                uid: vue.item.part_data.uid,
                                libraryRevisionId: revisionId,
                                exportFormatId: vue.formatSelected
                            }
                            

                            vue.$store.dispatch("pm_appendFilesToLibrary", objAppend)
                                .then(function (result) {

                                    console.log(result)

                                    if (result.status == "OK") {

                                        // const obj = {
                                        //     name: vue.libraryName,
                                        //     prototype: true,
                                        //     symbolId: result.data
                                        // }

                                        if (vue.source === PartPropertiesType.SYMBOL || vue.source === PartPropertiesType.HDLSYMBOL) {
                                            const objSymbol = {
                                                name: vue.$store.getters.libraryULObject.name,
                                                prototype: true,
                                                symbolId: result.data
                                            }
                                            vue.$store.commit("ADDSELECTEDSYMBOLS", objSymbol)
                                        }



                                        if (vue.source === PartPropertiesType.FOOTPRINT) {
                                            const objFootprint = {
                                                name: vue.$store.getters.libraryULObject.name,
                                                prototype: true,
                                                footprintId: result.data

                                            }
                                            vue.$store.commit("ADDSELECTEDFOOTPRINTS", objFootprint)
                                        }

                                        vue.$store.commit("RESETPROPERTYTOSAVINGUL");

                                        vue.isCreating = false;

                                        const objModal = {
                                            ok: false,
                                            cancel: false
                                        }

                                        vue.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)

                                        vue.$parent.$parent.$parent.switchTabIndex(0)
                                        
                                        
                                                

                                    } else {

                                        
                                        const objModal = {
                                            ok: true,
                                            cancel: false
                                        }

                                        vue.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)
                                        
                                        let obj = {
                                            text: vue.lang.alert_error_appendfiles_UL + " " + result.message,
                                            time: 20,
                                            type: "danger"
                                        }
                                        vue.$store.dispatch("displayFooterAlert", obj);

                                        const modalAlert = {
                                            text: vue.lang.alert_error_appendfiles_UL + " " + result.message,
                                            time: 20,
                                            type: "danger"
                                        }
                                        vue.$store.commit("SETMODALALERT", modalAlert);
                                    }

                                })


                        } else {

                            vue.isCreating = false;

                            let obj = {
                                text: "The new library has not been saved. Error.",
                                time: 15,
                                type: "danger"
                            }

                            vue.$store.dispatch("displayFooterAlert", obj);

                            const modalAlert = {
                                text: "The new library has not been saved. Error.",
                                time: 15,
                                type: "danger"
                            }
                            vue.$store.commit("SETMODALALERT", modalAlert);

                            const objModal = {
                                ok: true,
                                cancel: false
                            }

                            vue.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)
                        }



                    } else {
                        let obj = {
                            text: "The new library has not been saved. Error" + ": " + result.message,
                            time: 15,
                            type: "danger"
                        }

                        vue.$store.dispatch("displayFooterAlert", obj);

                        const modalAlert = {
                            text: "The new library has not been saved. Error" + ": " + result.message,
                            time: 15,
                            type: "danger"
                        }
                        vue.$store.commit("SETMODALALERT", modalAlert);

                        vue.isCreating = false;

                        const objModal = {
                            ok: true,
                            cancel: false
                        }

                        vue.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)
                    }


                })

            
            
        }


    }
}
</script>


<style  lang="scss">


        

    .LibraryULComponent{

        .ul-logo{
            width: 100px;
            margin: 20px;
        }
        .svg-img{
            background-color: #ffffff;
            border: 1px solid #dee2e6;
            border-radius: 0.25rem;
            margin: 5px;
            //overflow: hidden;
            width: 300px;
            height: 300px;
            display: block;
        }
        svg {
            display: block;
            width: 90%;
            height: 90%;
            //position: relative;
            //top: 0;
            //left: 0;
            overflow: hidden;
            //vertical-align: middle;
        }
        .name{
            font-size: 1rem;
        } 
        .button-create{
            float: right;
            margin: 10px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/shared/LibraryULComponent.vue